// extracted by mini-css-extract-plugin
module.exports = {"add-user-page-container":"AddUserPage_add-user-page-container__yyP3G","add-user-toolbar":"AddUserPage_add-user-toolbar__1q1ui","form-container":"AddUserPage_form-container__2CGsT"};